import {
    ChannelRoomStoreState,
    InitChannelroomStoreConfig,
    useChannelRoomStore as useChannelRoomStoreHook,
    useChannelStore,
    useChatStore,
} from "@obsbot/remo-stores";
import { RouteNameType, usePushHistory } from "./routes";
import { errorTips, useSafePromise } from "remo-components";
import { useEffect, useState } from "react";
import { RemoServices } from "@obsbot/remo-services";

export type useChannelroomStoreConfig = Omit<InitChannelroomStoreConfig, "rtc" | "rtm">;
export function useChannelroomStore(
    config: useChannelroomStoreConfig,
): ChannelRoomStoreState | undefined {
    const [channelroomStore, setChannelroomStore] = useState<ChannelRoomStoreState>();
    const pushHistory = usePushHistory();
    const sp = useSafePromise();
    const title = channelroomStore?.roomInfo()?.channelName;
    useEffect(() => {
        if (title) {
            document.title = title;
        }
    }, [title]);
    useEffect(() => {
        let isUnmounted = false;
        const remoServices = RemoServices.getInstance();
        const unsubscribe = useChannelRoomStoreHook.subscribe(state => {
            if (!isUnmounted) {
                setChannelroomStore(state);
            }
        });
        console.log("[DEBUG LOG] 请求service use-channelroom-store");
        sp(Promise.all([remoServices.requestService("videoChat")])).then(([videoChat]) => {
            if (!isUnmounted && videoChat) {
                const rtm = useChatStore.getState().rtm!;
                const channelroomStoreConfig: InitChannelroomStoreConfig = {
                    ...config,
                    rtc: videoChat,
                    rtm,
                };
                const channelStore = useChannelStore.getState();
                if (config.roomUUID !== channelStore.activeChannel?.channelUuid) {
                    const channels = channelStore.channels;
                    const curActiveChannel = channels.get(config.roomUUID);
                    if (!curActiveChannel) {
                        channelStore.queryChannelInfo(config.roomUUID).then(channelInfo => {
                            channelStore.updateActiveChannel(channelInfo);
                        });
                    }
                }
                useChannelRoomStoreHook.getState()?.initStore(channelroomStoreConfig);
                const channelroomStore = useChannelRoomStoreHook.getState();
                setChannelroomStore(channelroomStore);
                sp(channelroomStore.init()).catch(e => {
                    errorTips(e);
                    pushHistory(RouteNameType.ChannelPage);
                });
            }
        });
        return () => {
            isUnmounted = true;
            // channelroomStore?.destroy();
            unsubscribe();
            // remoServices.shutdownService("videoChat");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config.roomUUID]);
    return channelroomStore;
}
